module.exports = __webpack_public_path__ + "img/shop.47267125.png";